// Ephemeral candidate session — sessionStorage so the flow doesn't survive a full tab close.
const KEY = "candidateSession";

export interface CandidateSession {
  quizId: string;
  candidateId: string;
  token: string;
  expiresAt: string;
  attemptId?: string;
}

export function saveSession(s: CandidateSession) {
  sessionStorage.setItem(KEY, JSON.stringify(s));
  sessionStorage.setItem("candidateToken", s.token);
}

export function loadSession(): CandidateSession | null {
  const raw = sessionStorage.getItem(KEY);
  return raw ? (JSON.parse(raw) as CandidateSession) : null;
}

export function clearSession() {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem("candidateToken");
}
